import React from 'react'
import Slider from 'react-slick';
import { PurchaseContext } from '../contexts/PurchaseContext';

type Props = {
    onClick: Function
}

export default function BundleCarousel(props: Props) {
    const [purchaseState] = React.useContext(PurchaseContext);
    const {onClick} = props;
    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        onClick(event);
    }

    const sliderElements: React.JSX.Element[] = [];
    data.forEach(item => {
        sliderElements.push((
            <div key={item.family} className="text-center slider-item">
                <div className="d-flex h-100 justify-content-center align-items-center">
                        <input type="image" disabled={purchaseState.loading} data-product={item.family} data-subproduct={item.subFamily}
                        onClick={handleClick} src={item.imgSrc} style={{height: '100%', width: 'auto', maxWidth: '100%'}}>
                        </input>
                </div>
                <br />
                <h5>{item.title}</h5>
                <p style={{ fontSize: '12px' }}>{item.description}</p>
            </div>
        ))
    })

    return (
        <div>
            <h2 className="text-center">You May Also Like</h2>
            <Slider {...settings}>
                {sliderElements}
            </Slider>
        </div>
    )
}

const data = [
    {
        family: 'Training Products',
        subFamily: 'Mocha Essentials',
        title: 'Mocha Essentials',
        description: '7 hours of Mocha Training',
        imgSrc : 'https://cdn.shopify.com/s/files/1/1222/4522/products/mocha-essentials-mosaic-01.jpg?v=1617716317'
    },
    {
        family: 'Continuum Premium Filters',
        subFamily: 'Continuum Filter - Beauty Studio',
        title: 'Beauty Studio',
        description: 'Skin Smoothing & Digital Makeup',
        imgSrc : 'https://borisfx-com-res.cloudinary.com/image/upload/q_auto,f_auto/v1679055920/Marketing/2023_Logo_Redesign/Continuum.webp'
    },
    {
        family: 'Presets and Templates',
        subFamily: 'Sapphire Nitro FX, V1',
        title: 'Nitro FX',
        description: 'Presets for Avid Sapphire Owners',
        imgSrc : 'https://borisfx-com-res.cloudinary.com/image/upload/q_auto,f_auto/v1679055918/Marketing/2023_Logo_Redesign/Sapphire_2023.webp'
    },
    {
        family: 'Continuum Premium Filters',
        subFamily: 'Continuum Filter - Primatte Studio',
        title: 'Primatte Studio',
        description: 'Premium Keying Plugin',
        imgSrc : 'https://borisfx-com-res.cloudinary.com/image/upload/q_auto,f_auto/v1679055920/Marketing/2023_Logo_Redesign/Continuum.webp'
    },
    {
        family: 'Optics',
        subFamily: null,
        title: 'Optics',
        description: 'VFX Plugin for Photoshop',
        imgSrc : 'https://borisfx-com-res.cloudinary.com/image/upload/q_auto,f_auto/v1679055920/Marketing/2023_Logo_Redesign/Optics_2023.webp'
    }
]

const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 800,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
}
